import CheckoutSimplifiedForm from "./CheckoutSimplifiedForm/CheckoutSimplifiedForm";
import { CheckoutSimplifiedUIProvider } from "./CheckoutSimplifiedUIProvider";

const CheckoutSimplifiedFlow = () => {
  return (
    <CheckoutSimplifiedUIProvider>
      <CheckoutSimplifiedForm />
    </CheckoutSimplifiedUIProvider>
  );
};

export default CheckoutSimplifiedFlow;
